import * as React from "react";

export default function AppFooter() {
  return (
    <footer className="trps-footer">
      <div className="trps-footer__inner">
        <img src="/icon/TRAPS_logo_h_inv_tight.svg" alt="TRAPS" />
        <div className="trps-footer__meta">© {new Date().getFullYear()} TRAPS</div>
      </div>
    </footer>
  );
}
